module.exports = __webpack_public_path__ + "2b21866385134f3eb1552d46a99c4ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/large_360x360_noicon.png
// module id = 746
// module chunks = 0